<ng-container *ngIf="item">
  <!-- Main container -->
  <nav class="level">
    <!-- Left side -->
    <div class="level-left">
      <div class="level-item">
        <h1 class="title is-2 has-text-weight-light">
          User Profile
        </h1>
      </div>
    </div>
  </nav>

  <div class="columns is-multiline">
    <div class="column is-8">
      <div class="card">
        <div class="card-content">
          <h4 class="is-uppercase has-text-dark has-text-weight-medium mb-4 is-size-6">
            Personal Information
          </h4>

          <table class="table is-fullwidth">
            <tbody>
              <tr>
                <td class="has-text-grey-darker has-text-weight-medium">
                  Name:
                </td>
                <td>{{ item.name || '-' }}</td>
              </tr>
              <tr>
                <td class="has-text-grey-darker has-text-weight-medium">
                  Email:
                </td>
                <td>{{ item.email || '-' }}</td>
              </tr>
              <tr *ngIf="isAdmin()">
                <td class="has-text-grey-darker has-text-weight-medium">
                  Keycloak ID:
                </td>
                <td class="is-family-monospace is-size-7">{{ item.keycloakId || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="card mt-6" *ngIf="showOrgProfile">
        <div class="card-content">
          <div class="is-flex is-justify-content-space-between is-align-items-center mb-4">
            <h4 class="is-uppercase has-text-dark has-text-weight-medium is-size-6 mb-0">
              Organization Information
            </h4>
            <a *ngIf="!editingProfile" class="is-size-7 has-text-link" (click)="editingProfile = true">Edit</a>
          </div>

          <!-- Read-only view -->
          <ng-container *ngIf="!editingProfile">
            <table class="table is-fullwidth">
              <tbody>
                <tr>
                  <td class="has-text-grey-darker has-text-weight-medium">Organization:</td>
                  <td>{{ profileForm.organizationName || '-' }}</td>
                </tr>
                <tr>
                  <td class="has-text-grey-darker has-text-weight-medium">Country:</td>
                  <td>{{ getCountryLabel(profileForm.country) }}</td>
                </tr>
                <tr>
                  <td class="has-text-grey-darker has-text-weight-medium">Website:</td>
                  <td>{{ profileForm.website || '-' }}</td>
                </tr>
              </tbody>
            </table>
          </ng-container>

          <!-- Edit form -->
          <ng-container *ngIf="editingProfile">
            <div class="field">
              <label class="label">Organization Name</label>
              <div class="control">
                <input class="input" type="text" [(ngModel)]="profileForm.organizationName" placeholder="Organization name">
              </div>
            </div>

            <div class="field">
              <label class="label">Country</label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select [(ngModel)]="profileForm.country">
                    <option value="" disabled>Select a country</option>
                    <option *ngFor="let c of oecdCountries" [value]="c.value">{{ c.label }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="field">
              <label class="label">Website</label>
              <div class="control">
                <input class="input" type="url" [(ngModel)]="profileForm.website" placeholder="https://example.com">
              </div>
            </div>

            <div class="field">
              <div class="control">
                <button
                  class="button is-primary"
                  [class.is-loading]="savingProfile"
                  [disabled]="savingProfile || !profileForm.organizationName || !profileForm.country || !profileForm.website"
                  (click)="saveProfile()">
                  Save
                </button>
                <button
                  class="button is-light ml-2"
                  [disabled]="savingProfile"
                  (click)="cancelEditProfile()">
                  Cancel
                </button>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="card mt-6" *ngIf="isAdmin()">
        <div class="card-content">
          <h4 class="is-uppercase has-text-dark has-text-weight-medium mb-4 is-size-6">
            Role & Permissions
          </h4>

          <div class="content">
            <p class="mb-2">
              <strong>Role:</strong>
              <a *ngIf="item.role" [routerLink]="['/roles', item.role.id, 'edit']" class="tag is-info is-link ml-2">
                {{ item.role.name }}
              </a>
              <span *ngIf="!item.role" class="tag is-light ml-2">-</span>
            </p>

            <div *ngIf="item.role?.permissions && item.role.permissions.length > 0">
              <p class="has-text-weight-medium mb-2">Permissions:</p>
              <div class="tags">
                <span class="tag is-light" *ngFor="let permission of item.role.permissions">
                  {{ permission.name }}
                </span>
              </div>
            </div>

            <div *ngIf="!item.role?.permissions || item.role.permissions.length === 0">
              <p class="has-text-grey">No permissions assigned</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="column is-4">
      <div class="card">
        <div class="card-content">
          <h4 class="is-uppercase has-text-dark has-text-weight-medium mb-4 is-size-6">
            Countries/Territories
          </h4>

          <div class="content">
            <ng-container *ngIf="item.countries && item.countries.length > 0">
              <ul>
                <li *ngFor="let country of item.countries">
                  <span class="is-size-6">
                    <span class="flag-icon flag-icon-{{ country.code?.toLowerCase() }} mr-2"></span>
                    {{ country.name }}
                  </span>
                </li>
              </ul>
            </ng-container>

            <ng-container *ngIf="!item.countries || item.countries.length === 0">
              <p class="has-text-grey">No countries found</p>
            </ng-container>
          </div>
        </div>
      </div>

    </div>
  </div>
</ng-container>

<ng-container *ngIf="!item">
  <div class="notification is-info is-light">
    <p>Loading user profile...</p>
  </div>
</ng-container>
